// import axios from "axios";

// const API_BASE = process.env.REACT_APP_PRODUCT_SERVICE_URL;

// const axiosClient = axios.create({
//   baseURL: API_BASE,
// });

// // Request interceptor (attach token automatically)
// axiosClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("authToken");

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// // Response interceptor (handle 401 globally)
// axiosClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       // optional: trigger logout or redirect
//       console.error("Unauthorized - logging out...");
//       localStorage.clear();
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   },
// );

// export default axiosClient;

import axios from "axios";

const API_BASE = process.env.REACT_APP_PRODUCT_SERVICE_URL;

if (!API_BASE) {
  throw new Error("Missing REACT_APP_PRODUCT_SERVICE_URL");
}

const axiosClient = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(
      "Axios API error:",
      error.response?.status,
      error.response?.data,
    );

    return Promise.reject(error);
  },
);

export default axiosClient;
